import { IAutomationObject } from '../../types'

export interface ISP_Puffer extends IAutomationObject {
    isOn: boolean;
    isMan: boolean;
    errSum: boolean;
}

export const schema = 'AutomationApps.SubPlants.Puffers.SP_Puffer';

